// @flow

import Merchant from '../Merchant';
import type {
  TConfigAggregatorOptions,
  TConfigAggregators,
  TConfigOptions,
} from './types';

export default class Config {
  initialized: boolean;
  token: ?string;
  entity_id: ?string;
  mch_id: ?string;
  mask: ?string;
  team_name: ?string;
  aggregator: ?TConfigAggregators;
  aggregator_options: ?TConfigAggregatorOptions;

  constructor(options: TConfigOptions) {
    const url = new URL(window.location.href);

    this.initialized = options.initialized || false;
    this.token = options.token || url.searchParams.get('token') || null;
    this.entity_id = options.entity_id || url.searchParams.get('entity_id') || null;
    this.mch_id = options.mch_id || null;
    this.mask = options.mask || null;
    this.team_name = options.team_name || null;
    this.aggregator = options.aggregator || null;
    this.aggregator_options = options.aggregator_options || null;
  }

  static init(options: TConfigOptions): Config {
    return new Config(options);
  }

  toObject(): TConfigOptions {
    return {
      initialized: this.initialized,
      token: this.token,
      entity_id: this.entity_id,
      mch_id: this.mch_id,
      mask: this.mask,
      team_name: this.team_name,
      aggregator: this.aggregator,
      aggregator_options: this.aggregator_options,
    };
  }

  set(key: string, value: any): Config {
    return Config.init(
      Object.assign({}, this.toObject(), { [key]: value }),
    );
  }

  getNavTo(merchants: Array<Merchant>): { path: string, state: {} } {
    const matchedMerchant = merchants.find(mch => mch.mch_id === this.mch_id);

    if (matchedMerchant) return {
      path: '/form',
      state: { merchant: matchedMerchant, mask: this.mask },
    };

    return { path: '/search', state: {} };
  }
}
